import styled from '@emotion/styled';
import * as tokens from '@tokens';
import type { PropsOf } from '@emotion/react';

export interface TabProps extends PropsOf<'button'> {
  /**
   * If the tab is selected or not.
   */
  isSelected?: boolean;
  /**
   * Styles override.
   */
  className?: string;
}

const StyledTab = styled.button<TabProps>`
  ${tokens.text('body2')};
  height: ${tokens.spacer.x6};
  padding: 0 ${tokens.spacer.x2};
  position: relative;
  cursor: pointer;
  outline: none;
  border: 1px solid ${tokens.color.ui_border};
  border-left: none;

  &:first-of-type {
    border-left: 1px solid ${tokens.color.ui_border};
  }

  ${({ isSelected }) =>
    isSelected
      ? `
        background: ${tokens.color.ui_background};
        color: ${tokens.color.text_default};
        border-bottom: 1px solid ${tokens.color.ui_background};
        `
      : `
        background: ${tokens.color.neutral_100};
        color: ${tokens.color.text_light};

        &:hover {
          background: ${tokens.color.neutral_200};
          color: ${tokens.color.text_light};
        }
    `};

  &:focus {
    ${tokens.focus()};
    border-color: transparent;
    // We need the z-index to ensure the focus ring appears above tab siblings.
    z-index: 1;
  }
`;

// the 'tab' role shouldn't be applied until a proper support for keyboard is introduced

export const Tab = (props: TabProps): JSX.Element => <StyledTab {...props} />;

Tab.defaultProps = {
  isSelected: false,
};
